/// <amd-module name="TFS/Admin/Views/GitHubConnection/Components/GitHubConnection" />
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IGitHubConnectionProps } from "TFS/Admin/Views/GitHubConnection/Models";
import { getGitHubConnectionModule } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionModule";
import { ConnectedGitHubConnectionInitializer } from "TFS/Admin/Views/GitHubConnection/Components/GitHubConnectionInitializer";

export class GitHubConnection extends VssComponent<IGitHubConnectionProps> {
    private _context: IVssComponentContext;

    constructor(props: IGitHubConnectionProps, context: IVssComponentContext) {
        super(props, context);

        this._context = context;
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getGitHubConnectionModule()]}>
                <ConnectedGitHubConnectionInitializer context={this._context} />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("gitHubConnectionView", GitHubConnection);
